import { FeatureFlags } from '#lib/constants/feature-flags.js';
import { editionsGalleryPageLoad } from '#lib/websites/editions/pages/EditionsGalleryPage/utils/editionsGalleryPageLoad/editionsGalleryPageLoad.js';
import { editionsGalleryPageLoadGql } from '#lib/websites/editions/pages/EditionsGalleryPage/utils/editionsGalleryPageLoadGql/editionsGalleryPageLoadGql.js';

export const load = FeatureFlags.RestPages['/editions/gallery']
	? editionsGalleryPageLoad
	: editionsGalleryPageLoadGql;
